export default "__VITE_ASSET__BLQuEfv8__"